export const pressOneLinkRegexp = /^https:\/\/press\.one\/files\/([a-f0-9]+)$/;
export const wechatLinkRegexp = /^https:\/\/mp\.weixin\.qq\.com\/s.*$/;
